/**
 * Joins `VITE_API_URL` with a path using a single `/` between them.
 * Trailing slashes on the base and leading slashes on `path` are stripped, so
 * e.g. `https://host/v1/` + `/invitations/...` → `https://host/v1/invitations/...`.
 */
export function buildApiUrl(path: string): string {
  const base = import.meta.env.VITE_API_URL;
  if (!base) {
    throw new Error('VITE_API_URL is not configured');
  }
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
